var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.animate),attrs:{"id":"animated_heading"}},[_vm._v(" "+_vm._s(_vm.headings[_vm.currentHeadingIndex])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }